export const updateSSOStateReducer = {
  updateSSOState: (state, action) => {
    const { customerId, authorization } = action.payload;
    state.ssoCustomerId = customerId;
    state.ssoAuthorization = authorization;
  },
};
